import type { AttachmentReference } from '../types/orderConfirmation'
import type { InboxAttachment } from '../types/inbox'

const API_BASE_URL = import.meta.env.VITE_API_GATEWAY_URL || ''

/** Authenticated API route that proxies attachment bytes from S3 (avoids browser CORS). */
export function attachmentContentUrl(attachmentId: string): string {
  return `${API_BASE_URL}/v1/attachments/${attachmentId}/content`
}

export function inboxAttachmentToReference(attachment: InboxAttachment): AttachmentReference {
  return {
    id: attachment.id,
    name: attachment.name,
    bucket: attachment.bucket,
    organization_id: attachment.organization_id,
    workflow_id: attachment.workflow_id,
    process_id: attachment.process_id,
  }
}
